import { motion } from 'motion/react'
import { forwardRef } from 'react'

import { useWindowResize } from '@utils/domUtils'

import { Widget, type WidgetProps } from './Widget'

import styles from './Widget.module.scss'

export const WidgetContainer = forwardRef<HTMLDivElement, WidgetProps>((props, ref) => {
  const isMobile = useWindowResize()

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, width: isMobile ? undefined : 0 }}
      animate={{ opacity: 1, width: isMobile ? undefined : 'var(--widget-width)' }}
      exit={{ opacity: 0, width: isMobile ? undefined : 0 }}
      transition={{ duration: 0.16, ease: 'easeIn' }}
      className={styles.widgetContainer}
    >
      <Widget {...props} />
    </motion.div>
  )
})

WidgetContainer.displayName = 'WidgetContainer'
